import { render, staticRenderFns } from "./BuyProfileModal.vue?vue&type=template&id=4a8fba57&scoped=true&"
import script from "./BuyProfileModal.vue?vue&type=script&lang=js&"
export * from "./BuyProfileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8fba57",
  null
  
)

export default component.exports